module.exports = {
      id: "prize-yellow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#prize-yellow",
      toString: function () {
        return this.url;
      }
    }